module.exports = {
    __lang__: 'zh-cn',
    windowView: '窗口视图',
    windowStyle: '窗口样式',
    windowController: '控制器',
    variableManagement: '变量管理',
    eventManagement: '事件管理',
    datasourceManagement: '数据源管理',
    depvarstitle: '依赖列表',
    supvarstitle: '变量列表',
    supeventstitle: '事件列表',
    datasourceList: '数据源列表',
    addDatasource: '添加数据源',
    datasourceEditor: '添加编辑器',
    save: '保存',
    testSql: '测试 SQL',
    delete: '删除',
    normal: '正常',
    saved: '已保存',
    syserr: '系统错误',
    datasourceDeleteTips: '确认要删除该数据源?',
    variableName: '变量名',
    eventName: '事件名',
    description: '描述...',
    add: '添加'
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/locale.zh-cn.js
 ** module id = 6
 ** module chunks = 0
 **/